import { MessagingChannel } from 'jschannel';
import { ReceivedResultType, StatementOptions, VERB_ID } from '@/components/C1Opener/OpenerTypes';
import { sendMessageToContainer } from '@/components/C1Opener/SendMessageUtils';

export async function sendReceivedStatement(
    channel: MessagingChannel,
    contentId: string,
    receivedResultType: ReceivedResultType,
    response: string,
    data?: unknown,
    options?: StatementOptions
): Promise<unknown> {
    const verbId = options?.verbId ?? VERB_ID;
    return sendMessageToContainer(channel, 'newStatements', [
        {
            verb: {
                id: `${verbId}/receive`,
                display: {
                    und: 'received'
                }
            },
            object: {
                id: contentId
            },
            result: {
                type: receivedResultType,
                response: response,
                data: data
            }
        }
    ]);
}